'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isDefined = function isDefined(data) {
  return typeof data !== 'undefined';
};
exports.default = isDefined;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/utils/isDefined.js
// module id = 67
// module chunks = 0